import { createContext, useContext, useState, useEffect } from 'react';
import { translations } from './translations';
import { pageTranslations } from './pageTranslations';
import { blogArticleTranslations } from './blogArticleTranslations';

// Merge translations
const mergedTranslations = {
  en: { ...translations.en, ...pageTranslations.en, ...blogArticleTranslations.en },
  lv: { ...translations.lv, ...pageTranslations.lv, ...blogArticleTranslations.lv },
  lt: { ...translations.lt, ...pageTranslations.lt, ...blogArticleTranslations.lt },
  ee: { ...translations.ee, ...pageTranslations.ee, ...blogArticleTranslations.ee },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // URL ?lang= param takes priority (shareable links), then saved preference
    if (typeof window !== 'undefined') {
      const urlLang = new URLSearchParams(window.location.search).get('lang');
      if (urlLang && ['en', 'lv', 'lt', 'ee'].includes(urlLang)) {
        return urlLang;
      }
      return localStorage.getItem('0g-language') || 'en';
    }
    return 'en';
  });

  useEffect(() => {
    // Save language preference
    localStorage.setItem('0g-language', language);
    // Update HTML lang attribute
    document.documentElement.lang = language === 'ee' ? 'et' : language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = mergedTranslations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback to English
        value = mergedTranslations['en'];
        for (const k2 of keys) {
          if (value && value[k2]) {
            value = value[k2];
          } else {
            return key; // Return key if translation not found
          }
        }
        break;
      }
    }
    
    return value;
  };

  const changeLanguage = (lang) => {
    if (['en', 'lv', 'lt', 'ee'].includes(lang)) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
